const schema = {
  answers: {
    type: 'answers',
    fields: {
      duration: 'string',
      is_correct: 'boolean'
    },
    relationships: {
      question: {
        type: 'questions'
      },
      alternative: {
        type: 'alternatives'
      }
    }
  },
  questions: {
    type: 'questions',
    fields: {
      description: 'string'
    }
  },
  alternatives: {
    type: 'alternatives',
    fields: {
      name: 'string',
      description: 'string'
    }
  },
  comments: {
    type: 'comments',
    fields: {
      body: 'string'
    },
    relationships: {
      user: { type: 'users' }
    }
  },
  posts: {
    type: 'posts',
    fields: {
      body: 'string',
      postType: 'string',
      userId: 'integer',
      createdAt: 'date',
      updatedAt: 'date',
      likesCount: 1,
      commentsCount: 1
    },
    relationships: {
      user: { type: 'users' },
      magicLinks: { type: 'magicLinks' },
      comments: { type: 'comments' },
      taxonomies: { type: 'taxonomies' },
      like: { type: 'userInteractions' },
      bookmark: { type: 'bookmarks' }
    }
  },
  users: {
    type: 'users',
    fields: {
      name: 'string',
      email: 'string',
      password: 'string',
      remote_image_url: 'string',
      slug: 'string',
      can_receive_newsletter: 'boolean',
      subscribed_open: 'boolean'
    },
    relationships: {
      objective: { type: 'objectives' },
      'user-detail': { type: 'user-details' }
    }
  },
  taxonomies: {
    type: 'taxonomies',
    fields: {
      name: 'string',
      description: 'string'
    },
    relationships: {
      'taxonomy-children': { type: 'taxonomies' }
    }
  },
  'learning-paths': {
    type: 'learning-paths',
    fields: {
      name: 'string',
      slug: 'string',
      kind: 'string',
      icon: 'string',
      description: 'string',
      position: 'integer'
    }
  },
  'user-learning-paths': {
    type: 'user-learning-paths',
    fields: {
      status: 'string',
      learningPathId: 'integer',
      percentWalked: 'integer',
      percentMastered: 'integer'
    },
    relationships: {
      'learning-path': { type: 'learning-paths' },
      'user-learning-path-blocks': { type: 'user-learning-path-blocks' },
      'user-streak': { type: 'user-streaks' }
    }
  },
  'user-learning-path-blocks': {
    type: 'user-learning-path-blocks',
    fields: {
      position: 'integer',
      kind: 'string',
      state: 'string'
    },
    relationships: {
      taxonomy: { type: 'taxonomies' },
      'user-learning-path-block-sections': { type: 'user-learning-path-block-sections' }
    }
  },
  'user-learning-path-block-sections': {
    type: 'user-learning-path-block-sections',
    fields: {
      position: 'integer',
      done: 'boolean'
    }
  },
  'user-streaks': {
    type: 'user-streaks',
    fields: {
      currentCount: 'integer',
      longestCount: 'integer',
      lastActivityOn: 'date'
    }
  }
};

export default schema;
